import { Box, Button, Card, CardContent, Chip, CircularProgress, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useKbArticle } from '../api/hooks';

export function KbArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const { data: article, isLoading, isError } = useKbArticle(slug);

  if (isLoading) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError || !article) {
    return (
      <Box>
        <Button onClick={() => navigate('/kb')} sx={{ mb: 2 }}>
          ← Back to knowledge base
        </Button>
        <Typography color="text.secondary">
          Sorry, we couldn't find that article. It may have been removed or is not available.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Button onClick={() => navigate('/kb')} sx={{ mb: 1 }}>
        ← Back to knowledge base
      </Button>

      <Typography variant="h1" sx={{ mb: 1 }}>
        {article.title}
      </Typography>

      {article.category && <Chip label={article.category} variant="outlined" sx={{ mb: 2 }} />}

      <Card variant="outlined">
        <CardContent>
          <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
            {article.body}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
